import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M8 1.833A2.833 2.833 0 1 0 8 7.5a2.833 2.833 0 0 0 0-5.667ZM4.166 4.667a3.833 3.833 0 1 1 7.667 0 3.833 3.833 0 0 1-7.667 0ZM13.422 9.618c.442-.046.849.153 1.211.515.365.365.566.772.522 1.215-.041.417-.29.74-.522.972l-2.355 2.355a1.161 1.161 0 0 1-.316.226c-.104.052-.23.1-.358.12h-.008l-.899.127a.95.95 0 0 1-.817-.255.95.95 0 0 1-.255-.817l.127-.907c.02-.13.069-.255.12-.357.052-.102.126-.217.22-.312l2.36-2.36c.233-.232.555-.48.97-.522Zm.102.994c-.072.008-.19.06-.364.235l-2.36 2.359-.01.014a.379.379 0 0 0-.05.105l-.116.824.824-.116a.4.4 0 0 0 .106-.049l.005-.004.007-.007 2.36-2.36c.175-.175.227-.291.234-.363.004-.045.002-.174-.234-.41-.23-.23-.357-.232-.402-.228Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M12.333 10.352a.5.5 0 0 1 .615.348c.153.55.581.979 1.132 1.132a.5.5 0 0 1-.267.963 2.624 2.624 0 0 1-1.828-1.828.5.5 0 0 1 .348-.615ZM8 10.5c-2.985 0-5.227 1.954-5.227 4.167a.5.5 0 0 1-1 0C1.773 11.719 4.665 9.5 8 9.5c.741 0 1.456.107 2.124.308a.5.5 0 0 1-.288.957A6.37 6.37 0 0 0 8 10.5Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }